/**
 * Route constants for the legal documents (docs/OnboardingRevamp.md §3 N1).
 * The documents themselves don't exist yet — both routes render a placeholder
 * page until the lawyer-drafted texts land (see docs/TermsOfServicePrimitives.md
 * and the PreLaunchChecklist row). Link to these constants, never hard-code
 * the paths, so the eventual real pages swap in everywhere at once.
 */
export const TERMS_ROUTE = '/regulamin';
export const PRIVACY_POLICY_ROUTE = '/polityka-prywatnosci';
